import { motion } from "framer-motion";

export function TrustStatement() {
  return (
    <section className="py-20 md:py-28 bg-card">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl mx-auto text-center"
        >
          <p className="font-serif italic text-3xl md:text-4xl lg:text-5xl text-foreground leading-snug md:leading-snug">
            That's why we created Soul Safe Sanctuary: to help you move
            {" "}
            <br className="hidden md:block" />
            from{" "}
            <span className="relative inline-block">
              <span className="relative z-10">confusion</span>
              {/* Circle decoration */}
              <svg
                className="absolute -inset-2 md:-inset-3 z-0"
                viewBox="0 0 200 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  cx="100"
                  cy="40"
                  rx="95"
                  ry="35"
                  stroke="hsl(var(--destructive))"
                  strokeWidth="2"
                  strokeDasharray="4 4"
                  opacity="0.65"
                />
              </svg>
            </span>{" "}
            to{" "}
            <span className="relative inline-block">
              <span className="relative z-10 font-bold">confidence</span>
              {/* Underline decoration */}
              <svg
                className="absolute -bottom-2 left-0 w-full z-0"
                viewBox="0 0 200 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 8C40 2 80 6 100 4C120 2 160 8 198 3"
                  stroke="hsl(var(--accent))"
                  strokeWidth="3"
                  strokeLinecap="round"
                  opacity="0.8"
                />
              </svg>
            </span>{" "}
            in your{" "}
            <span className="relative inline-block">
              <span className="relative z-10">healing</span>
              {/* Circle decoration */}
              <svg
                className="absolute -inset-2 md:-inset-3 z-0"
                viewBox="0 0 160 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  cx="80"
                  cy="40"
                  rx="75"
                  ry="35"
                  stroke="hsl(var(--accent))"
                  strokeWidth="2"
                  strokeDasharray="4 4"
                  opacity="0.7"
                />
              </svg>
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>
  );
}
